import { GET_ALL_INACTIVITY_REPORT, SET_LOADING_INACTIVITY_REPORT } from './types'

const initialState = {
  data: { data: [], query: {} },
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_INACTIVITY_REPORT:
      return {
        ...state,
        data: action.payload,
      }

    case SET_LOADING_INACTIVITY_REPORT:
      return {
        ...state,
        isLoading: action.payload,
      }
    default:
      return state
  }
}
